import { useMemo } from 'react';

import { useClient } from 'urql';
import { fromPromise } from 'xstate';

import {
  VerifiedGroupsDocument,
  type VerifiedGroupsQuery,
  type VerifiedGroupsQueryVariables,
} from '../../../graphql/VerifiedGroups.generated';

// ─────────────────────────────────────────────────────────────────────────────

export const useFetchVerifiedGroupsActor = () => {
  const client = useClient();

  return useMemo(() => {
    return fromPromise(async () => {
      const response = await client
        .query<VerifiedGroupsQuery, VerifiedGroupsQueryVariables>(
          VerifiedGroupsDocument,
          {},
          { requestPolicy: 'network-only' },
        )
        .toPromise();

      if (response.error) {
        throw response.error;
      }

      if (!response.data) {
        throw new Error('missing_verified_groups');
      }

      return response.data.verifiedGroups;
    });
  }, [client]);
};
